export const POSTCARD_PRDS = {
    MAILING: "PRD-WHVSX0JNJ",
    NON_MAILING: "PRD-ENRS4XZIS"
};
